var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Outlined from './Outlined';
import Standard from './Standard';
var variantComponent = {
    standard: Standard,
    outlined: Outlined,
};
var Input = React.forwardRef(function (props, ref) {
    var value = props.value, variant = props.variant, clear = props.clear, onClear = props.onClear, InputProps = __rest(props, ["value", "variant", "clear", "onClear"]);
    var InputComponent = variantComponent[variant];
    return (React.createElement(InputComponent, __assign({ ref: ref, value: value }, InputProps)));
});
Input.defaultProps = {
    variant: 'outlined',
    fullWidth: true,
};
export default Input;
